'use strict';

/* jshint node: true, esnext: true, loopfunc: true, undef: true, unused: true */
/*
 * @author: 绝云（wensen.lws）
 * @description: utils for html
 */

var objectUtils = require('zero-lang/object');

var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
};
var unescapeMap = objectUtils.invert(escapeMap);

function createEscaper(map) {
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + objectUtils.keys(map).join('|') + ')';
    var testRegexp = new RegExp(source);
    var replaceRegexp = new RegExp(source, 'g');

    function escaper(match) {
        return map[match];
    }

    return function (string) {
        string = string === null ? '' : '' + string;
        return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
}

module.exports = {
    escape: createEscaper(escapeMap),
    unescape: createEscaper(unescapeMap)
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/zero-text/html.js
 ** module id = 34
 ** module chunks = 0
 **/